import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { FiPlus } from 'react-icons/fi';
import CreateKpiModal from "@features/admin/kpi/components/CreateKpiModal";
import KpiTable from "@features/admin/kpi/components/KpiTable";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useScopeId } from '@core/hooks/useRouteParamId';

const ManageKpi: React.FC = () => {
    const sid = useScopeId() ?? 0;

    // State to control the visibility of the Create KPI modal
    const [showCreate, setShowCreate] = useState(false);
    // Bumped after a create/edit so the table refetches in place (no full-page reload).
    const [refreshSignal, setRefreshSignal] = useState(0);


    return (
        <Container fluid className="py-4" data-testid="manage-kpi-container">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4" data-testid="manage-kpi-header-row">
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1" data-testid="manage-kpi-title">KPIs</h1>
                    <p className="text-muted mb-0" data-testid="manage-kpi-description">Manage Key Performance Indicators</p>
                </div>
                {Number.isFinite(sid) && sid > 0 && (
                    <RequirePermission mode="section" action={ACTION_CODES.CREATE_KPI} scopeType="NATION" scopeId={sid}>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            aria-label="Add KPI"
                            data-testid="add-kpi-button"
                        >
                            <FiPlus className="me-2" />
                            New KPI
                        </Button>
                    </RequirePermission>
                )}
            </div>

            <KpiTable
                showPagination={true}
                refreshSignal={refreshSignal}
                data-testid="kpi-table"
            />

            <CreateKpiModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                onChanged={() => setRefreshSignal((s) => s + 1)}
                data-testid="create-kpi-modal"
            />
        </Container>
    );
};

export default ManageKpi;
